<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        color="error"
        class="mr-2 btn-table"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('onCloseModal')" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>Confirma que deseja excluir o membro deste grupo?</h2>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="$emit('onCloseModal')">Cancelar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { memberGroupAPI } from '../../API/MemberGroupAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppModalConfirmDeleteMember',
  props: {
    member: { type: Object, required: true }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      this.setLoading(true)
      memberGroupAPI.delete(this.member.membroGrupos[0].membroGrupoId)
        .then(resp => {
          this.$emit('onCloseModal')
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao remover membro')
        })
    }
  }
}
</script>
